import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import type { Role } from '@/modules/auth/roles';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface AssignRoleParams {
  userId: string;
  role: Role;
}

export const useAssignRoleMutation = () => {
  return useMutation({
    mutationFn: async ({ userId, role }: AssignRoleParams) => {
      await fetchClient.POST('/administration/users/{userId}/roles/{role}', {
        params: {
          path: {
            userId,
            role,
          },
        },
      });
    },
    onSettled: () => {
      invalidateQuery(usersQueryKeys.list())();
    },
  });
};
